import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { sharpSansBold } from '@zocdoc/components/src/typography';

import MapPinSprite from './MapPin_Navy.svg';
import DoctorSprite from './Doctor.svg';
import InsuranceCardSprite from './InsuranceCard.svg';

const FilterHeaderContainer = styled.div`
    ${sharpSansBold(24, 40)}
    padding-bottom: 7px;
    border-bottom: 2px solid ${navy};
    margin: 28px 0 21px;
`;

const Icon = styled.span`
    display: inline-block;
    margin-right: 12px;
    vertical-align: middle;
    background-repeat: no-repeat;
`;

const CityIcon = styled(Icon)`
    height: 32px;
    width: 20px;
    background-image: url(${MapPinSprite});
`;

const SpecialtyIcon = styled(Icon)`
    height: 29px;
    width: 20px;
    background-image: url(${DoctorSprite});
`;

const InsuranceIcon = styled(Icon)`
    height: 18px;
    width: 28px;
    background-image: url(${InsuranceCardSprite});
`;

const FilterName = styled.span`
    color: ${navy};
    vertical-align: middle;
`;

function renderIcon(iconType) {
    switch (iconType) {
        case 'city':
            return (<CityIcon />);
        case 'specialty':
            return (<SpecialtyIcon />);
        case 'insurance':
            return (<InsuranceIcon />);
    }
}

export default function FilterHeader({ children, href, iconType }) {
    return (
        <FilterHeaderContainer>
            <a href={href}>
                {renderIcon(iconType)}
                <FilterName>{children}</FilterName>
            </a>
        </FilterHeaderContainer>
    );
}

FilterHeader.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    iconType: PropTypes.string.isRequired,
};
